import { Routes } from '@angular/router';

import { MpsIsAdminGuard } from '../mps/guards/mps-isadmin.guard';
import { MpsLoggedInGuard } from '../mps/guards/mps-loggedin.guard';
import { MpsTranslateTitleResolver } from '../mps/resolvers/mps-translate-title.resolver';
import { applicationRouteNames } from './application-route-names';

export const applicationRoutes: Routes = [
  { path: '', redirectTo: applicationRouteNames.ingredients, pathMatch: 'full' },
  {
    path: applicationRouteNames.ingredients,
    loadChildren: () => import('./features/ingredients/ingredients.routes').then((m) => m.ingredientRoutes),
    data: { title: 'general.navigation.ingredients' },
    canActivate: [MpsLoggedInGuard],
    canLoad: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.grades,
    loadChildren: () => import('./features/grades/grades.routes').then((m) => m.gradesRoutes),
    data: { title: 'general.navigation.grades' },
    canActivate: [MpsLoggedInGuard],
    canLoad: [MpsLoggedInGuard],
  },
  {
    path: applicationRouteNames.forecast,
    loadChildren: () => import('./features/forecast/forecast.routes').then((m) => m.forecastRoutes),
    data: { title: 'general.navigation.forecast' },
    canActivate: [MpsIsAdminGuard],
    canLoad: [MpsIsAdminGuard],
  },
  {
    path: applicationRouteNames.administration,
    data: { title: 'general.navigation.administration' },
    canActivate: [MpsIsAdminGuard],
    canLoad: [MpsIsAdminGuard],
    children: [
      {
        path: applicationRouteNames.users,
        loadComponent: () => import('./administration/users/list/list.component').then((m) => m.ListComponent),
        title: MpsTranslateTitleResolver,
        data: { title: 'general.navigation.users', titleKey: 'general.navigation.users' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.lokalise,
        loadComponent: () => import('./administration/lokalise/lokalise.component').then((m) => m.LokaliseComponent),
        title: MpsTranslateTitleResolver,
        data: { title: 'general.navigation.lokalise', titleKey: 'general.navigation.lokalise' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.lookups,
        loadComponent: () =>
          import('./administration/lookups/lookups-management.component').then((m) => m.LookupsManagementComponent),
        title: MpsTranslateTitleResolver,
        data: { title: 'general.navigation.lookups', titleKey: 'general.navigation.lookups' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.aggregate,
        loadComponent: () =>
          import('../mps/mpsaudit/components/mps-audit-aggregate/mps-audit-aggregate.component').then(
            (m) => m.MpsAuditAggregateComponent
          ),
        title: MpsTranslateTitleResolver,
        data: { title: 'general.navigation.aggregate', titleKey: 'general.navigation.aggregate' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
    ],
  },
];
